import { Logo } from "./Logo";

const TABS = [
    ["todos", "TODOS"],
    ["futebol", "FUTEBOL"],
    ["retro", "RETRÔ"],
    ["basquete", "BASQUETE"],
];

export const Header = ({ category, onSelect }) => (
    <header
        data-testid="site-header"
        className="fixed top-0 inset-x-0 z-40 bg-[#0B0B0B]/85 backdrop-blur-md border-b border-[#27272A]"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
            <button
                data-testid="header-brand"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="flex items-center gap-3"
            >
                <Logo size={28} />
                <span className="font-display font-extrabold tracking-tight text-sm sm:text-base uppercase whitespace-nowrap">
                    Campo <span className="text-[#FF6A00]">&</span> Concreto
                </span>
            </button>
            <nav className="hidden md:flex items-center gap-1">
                {TABS.map(([id, label]) => (
                    <button
                        key={id}
                        data-testid={`nav-tab-${id}`}
                        onClick={() => onSelect(id)}
                        className={`px-4 py-2 font-condensed font-bold uppercase tracking-widest text-sm transition-colors duration-300 ${
                            category === id
                                ? "text-[#FF6A00]"
                                : "text-[#A1A1AA] hover:text-white"
                        }`}
                    >
                        {label}
                    </button>
                ))}
            </nav>
        </div>
    </header>
);
